(function () {
    'use strict';

    angular
        .module('questionnaireTemplatesEditModule')
        .controller('ODDQuestionnaireTemplateEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'questionnaireTemplate', 'questionnaireTemplates'];

    function Controller($scope, $state, topBarService, businessUnit, questionnaireTemplate, questionnaireTemplates) {

        topBarService.setTitleAndIcon('Operational Due Diligence | ' + businessUnit.TitleEN, 'icon icon-clipboard');

        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireTemplates = questionnaireTemplates;

        $scope.goToQuestionnaireTemplatesList = function () {
            $state.go('odd.questionnaireTemplatesEdit', {}, { reload: true });
        };

        $scope.goToSectionListEdit = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.editSectionList', {
                 ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
            });
        };

        $scope.goToSection = function (section) {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.section', {
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID,
                ODDSectionID: section.ODDSectionID
            });
        };

        // Add Section
        $scope.addSection = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.addSection', {
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
            });
        };
    }
})();